import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ArquivoSearch } from '../../arquivo-search';

@Injectable({
    providedIn: 'root'
})
export class ArquivoPedidoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/arquivos`;
    }


    /** Seta se um arquivo está pendente na expedição */
    setPendenteExpedicao(idArquivo: number, pendente: boolean): Observable<ArquivoSearch> {
        return this.customHttp.put<ArquivoSearch>(`${this.pathApi}/${idArquivo}/pedido/expedicao/pendente/${pendente?.toString() ?? 'null'}`, null);
    }
}
